import { render, staticRenderFns } from "./OrganizationEnergyProvider.vue?vue&type=template&id=f70541ea"
import script from "./OrganizationEnergyProvider.vue?vue&type=script&lang=js"
export * from "./OrganizationEnergyProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports